// src/pages/SuperAdminDashboard.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { MdBusiness, MdPeople } from 'react-icons/md';
import { useAuth } from '../../context/AuthContext';
import SuperAdminSidebar from './SuperAdminSidebar';
import { Outlet } from 'react-router-dom';

const DashboardContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: #2d3748;
  margin-bottom: 2rem;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
`;

const StatCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const StatIcon = styled.div`
  background: #667eea;
  color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  svg {
    font-size: 1.5rem;
  }
`;

const StatContent = styled.div`
  flex: 1;
`;

const StatValue = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
`;

const StatLabel = styled.div`
  color: #718096;
  margin-top: 0.5rem;
`;

const DashboardLayout = styled.div`
  display: flex;
`;

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  margin-left: ${props => props.sidebarOpen ? '240px' : '64px'};
  transition: margin 0.3s ease;
  min-height: 100vh;
`;

const SuperAdminDashboard = () => {
  const { user, logout } = useAuth();
  // Dummy data - replace with API call
  const organizations = [
    { id: 1, name: 'Org 1', users: 3 },
    { id: 2, name: 'Org 2', users: 1 },
    { id: 3, name: 'Org 3', users: 4 },
  ];
  const [sidebarOpen, setSidebarOpen] = useState(true);


  return (
    <DashboardLayout>
     
      <Content sidebarOpen={false}>
        <h1>Super Admin Dashboard</h1>
        {/* Your dashboard content */}

        <StatsGrid>
        <StatCard>
          <StatIcon>
            <MdBusiness />
          </StatIcon>
          <StatContent>
            <StatValue>{organizations.length}</StatValue>
            <StatLabel>Organizations</StatLabel>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon>
            <MdPeople />
          </StatIcon>
          <StatContent>
            <StatValue>
              {organizations.reduce((sum, org) => sum + org.users, 0)}
            </StatValue>
            <StatLabel>Total Vendors</StatLabel>
          </StatContent>
        </StatCard>
      </StatsGrid>
       </Content>
    </DashboardLayout>
  );
};

export default SuperAdminDashboard;